<template>
  <div class="mt-2">
    <el-button type="success" @click="getExtendedUsers">
      Get Extended Users
    </el-button>
    <div v-if="extendedUsers.length">
      <div class="table-title">Reviewers</div>
      <el-table>
        <el-table-column prop="name" label="Metric" fixed width="200" />
        <el-table-column prop="value" label="Value" width="100" />
      </el-table>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const extendedUsers = ref([]);

const getExtendedUsers = () => {
  console.log("get extended users");
};
</script>

<style scoped>
.table-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;
}
</style>
